import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

import { Anchor } from '../../atoms';

const ItemContainer = styled.div`
  width: 100%;
  height: 40px;

  a {
    display: block;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    padding-left: ${theme.spacing.m};
    background-color: ${theme.colors.white};

    &:hover {
      color: inherit;
      background-color: ${theme.colors.gray100};
    }
  }
`;

const MenuItem = ({ children, href, onClick, ...props }) => {
  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <ItemContainer onClick={handleClick} {...props}>
      <Anchor to={href}>{children}</Anchor>
    </ItemContainer>
  );
};

MenuItem.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

MenuItem.defaultProps = {
  onClick: () => {},
};

export default MenuItem;
